const React = require('react');
const hash = require('object-hash');
const commonHeadTagList = require('./partials/common-head-tags');
const domainHeadTagList = require('./partials/domain-head-tags');

function generateHeadTags(headTagsList) {
  return headTagsList.map(tag => React.createElement(tag.tagName, Object.assign(tag.props, { key: hash(tag) })));
}

function generateCommonHeadTags() {
  return generateHeadTags(commonHeadTagList);
}

function generateDomainCommonHeadTags() {
  return generateHeadTags(commonHeadTagList.concat(domainHeadTagList));
}

module.exports = {
  generateCommonHeadTags,
  generateDomainCommonHeadTags,
};
